import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class QuarryFlooded2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.QUARRY_FLOODED2;
}

export default QuarryFlooded2PoiTileEntity;
